__turbopack_context__.v({
  "card": "Card-module__ckVvha__card",
});
